export default {"src":"/_next/static/media/CouchDB.f873714d.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};